import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImageLoaderService {

  preloadImages(imageLocations: Array<any>, type?: string): Promise<Array<any>> {
    const types = {
      image    : 'attachment_url',
      thumbnail: 'thumbnail_url'
    };

    const urlField = types[type] || 'attachment_url';
    let loadCount = 0;
    let errorOccurred = false;

    return new Promise((resolve, reject) => {
      if (!imageLocations || imageLocations.length === 0) {
        resolve([]);
        return;
      }

      const imageCount = imageLocations.length;

      imageLocations.forEach(location => {
        const imageUrl = location[urlField];
        const image = new Image();

        image.onload = () => {
          if (errorOccurred) return;

          loadCount++;

          if (loadCount === imageCount) {
            resolve(imageLocations);
          }
        };

        image.onerror = () => {
          if (errorOccurred) return;

          errorOccurred = true;
          reject(image.src);
        };

        image.src = imageUrl;
      });
    });
  }
}
